const menu = {
  namespaced: true,
  state: {
    selected: false,
    zoom: false,
    form: false,
    addForm: false
  },
  getters: {
    getSelected: (state) => state.selected,
    getZoom: (state) => state.zoom,
    getForm: (state) => state.form,
    getAddForm: (state) => state.addForm
  },
  mutations: {
    setSelected (state, selected) {
      state.selected = selected
    },
    setZoom (state, zoom) {
      state.zoom = zoom
    },
    setForm (state, form) {
      state.form = form
    },
    setAddForm (state, addForm) {
      state.addForm = addForm
    }
  },
  actions: {
    setSelected ({ commit }, selected) {
      commit('setSelected', selected)
    },
    setZoom ({ commit }, zoom) {
      commit('setZoom', zoom)
    },
    setForm ({ commit }, form) {
      commit('setForm', form)
    },
    setAddForm ({ commit }, addForm) {
      commit('setAddForm', addForm)
    }
  }
}

export default menu



// WEBPACK FOOTER //
// ./src/vuex/menu.js